/** A fresh, un-committed lock. */
export const initialLock = () => ({ state: 'open', revisionCount: 0 });
/**
 * Pure lock-state reducer: (lock, event) → next lock. Never grades - see the file header.
 *   open      + lockIn → lockedIn (records lockedAtDecisionIndex)
 *   open      + edit   → open (pre-lock edits don't count)
 *   lockedIn  + edit   → revised (revisionCount += 1)
 *   revised   + edit   → revised (revisionCount += 1)
 *   locked*   + lockIn → lockedIn (re-lock after a revise; first lock index is preserved)
 */
export const lockReducer = (lock, event) => {
    if (event.type === 'lockIn') {
        // first lock records the decision index; re-locking after a revise keeps the original index.
        const lockedAtDecisionIndex = lock.lockedAtDecisionIndex ?? event.atDecisionIndex;
        return { state: 'lockedIn', revisionCount: lock.revisionCount, lockedAtDecisionIndex };
    }
    // event.type === 'edit'
    if (lock.state === 'open')
        return lock; // nothing committed yet - no-op
    // a change after a lock (from lockedIn or revised) is a revision.
    return { ...lock, state: 'revised', revisionCount: lock.revisionCount + 1 };
};
//# sourceMappingURL=lock.js.map